import { styled } from '../../../theme/stitches.config';

const ARROW_SIZE = 8;

export const SMPTooltip = styled.withConfig({ componentId: 'CommonWidget', displayName: 'SMPTooltip' })('div', {
  position: 'absolute',
  bottom: `calc(100% + ${ARROW_SIZE}px + 2px)`,
  left: '50%',
  display: 'none',
  borderRadius: '$1',
  padding: '$1 $2',
  backgroundColor: '$statusBadgeBgColor',
  color: '$statusBadgeTextColor',
  whiteSpace: 'nowrap',
  fontSize: '$2_5',
  zIndex: '1000',
  cursor: 'pointer',
  transform: 'translateX(-50%)',

  '&::after': {
    content: '""',
    position: 'absolute',
    top: '100%',
    left: '50%',
    border: `${ARROW_SIZE}px solid transparent`,
    borderTopColor: '$statusBadgeBgColor',
    transform: 'translateX(-50%)',
    pointerEvents: 'none',
  },
});
